import { Twitter, Globe } from "lucide-react"

export function Footer() {
  return (
    <footer className="mt-4 w-full border-t-2 bg-foreground py-5 text-background">
      <div className="mx-auto flex w-full max-w-[1480px] flex-col items-center justify-between gap-3 px-4 font-mono text-xs uppercase tracking-wider sm:flex-row sm:px-6">
        <span>Built by Didac Sabates</span>
        <div className="flex items-center gap-4">
        <a
          href="https://x.com/didacsd"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 hover:text-accent"
        >
          @didacsd
          <Twitter className="h-4 w-4" />
        </a>
        <a
          href="https://didac.dev"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-1 hover:text-accent"
        >
          didac.dev
          <Globe className="h-4 w-4" />
        </a>
        </div>
      </div>
    </footer>
  )
}
